import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

export function useSelection(items) {
  const [sel, setSel] = useState([]);
  const ids = items.map((i) => i.id);
  const selected = sel.filter((id) => ids.includes(id));
  return {
    selected,
    has: (id) => selected.includes(id),
    toggle: (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id])),
    allChecked: ids.length > 0 && selected.length === ids.length,
    toggleAll: () => setSel(selected.length === ids.length ? [] : ids),
    clear: () => setSel([]),
  };
}

function Confirm({ label, title, testId, onConfirm, disabled, variant = "outline" }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant={variant} disabled={disabled} className={variant === "outline" ? "border-destructive/40 text-destructive hover:bg-destructive hover:text-destructive-foreground" : ""} data-testid={testId}><Trash2 className="mr-1.5 h-4 w-4" />{label}</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader><AlertDialogTitle>{title}</AlertDialogTitle><AlertDialogDescription>L'operazione non si può annullare.</AlertDialogDescription></AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid={`${testId}-confirm`}>Elimina</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function BulkDeleteBar({ endpoint, selection, total, onDone, prefix, noun }) {
  const del = async (body) => {
    try {
      const { data } = await api.post(endpoint, body);
      toast.success(`${data.deleted} ${noun} eliminate`);
      selection.clear();
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!total) return null;
  return (
    <div className="mb-3 flex flex-wrap items-center gap-3 rounded-md border bg-card px-4 py-2.5" data-testid={`${prefix}-bulk-bar`}>
      <label className="flex cursor-pointer items-center gap-2 text-sm">
        <Checkbox checked={selection.allChecked} onCheckedChange={selection.toggleAll} data-testid={`${prefix}-select-all`} />Seleziona tutte
      </label>
      <span className="text-xs text-muted-foreground" data-testid={`${prefix}-selected-count`}>{selection.selected.length} selezionate</span>
      <span className="ml-auto flex flex-wrap gap-2">
        <Confirm label="Elimina selezionate" title={`Eliminare ${selection.selected.length} ${noun}?`} disabled={!selection.selected.length} testId={`${prefix}-delete-selected`} onConfirm={() => del({ ids: selection.selected })} />
        <Confirm label="Elimina tutte" variant="destructive" title={`Eliminare tutte le ${noun}?`} testId={`${prefix}-delete-all`} onConfirm={() => del({ all: true })} />
      </span>
    </div>
  );
}
